/**
 * Created by kb on 2017/11/17.
 */
{
  //long 类型的时间 转换成Date 并格式化
  Number.prototype.timeformatDate = function (format) {
    let covertdate = new Date(this);
    return covertdate.format(format);
  }

//重新js的toFixed方法
  Number.prototype.toFixed = function (s) {
    let changenum = (parseInt(this * Math.pow(10, s) + 0.5) / Math.pow(10, s)).toString();
    let index = changenum.indexOf(".");
    if (index < 0 && s > 0) {
      changenum = changenum + ".";
      for (let i = 0; i < s; i++) {
        changenum = changenum + "0";
      }

    } else {
      index = changenum.length - index;
      for (let i = 0; i < (s - index) + 1; i++) {
        changenum = changenum + "0";
      }

    }
    return changenum;
  }

  //重写js除法运算
  Number.prototype.div = function (arg) {
    function accDiv(arg1, arg2) {
      let t1 = 0, t2 = 0, r1, r2;
      try {
        t1 = arg1.toString().split(".")[1].length
      } catch (e) {
      }
      try {
        t2 = arg2.toString().split(".")[1].length
      } catch (e) {
      }
      r1 = Number(arg1.toString().replace(".", ""))
      r2 = Number(arg2.toString().replace(".", ""))
      return (r1 / r2).mul(Math.pow(10, t2 - t1)) ;

    }

    return accDiv(this, arg);

  }

//重写js乘法运算
  Number.prototype.mul = function (arg) {
    function accMul(arg1, arg2) {
      let m = 0, s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length
      } catch (e) {
      }
      try {
        m += s2.split(".")[1].length
      } catch (e) {
      }
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m
        )
    }

    return accMul(arg, this);
  }

//重写js加法运算
  Number.prototype.add = function (arg) {
    function accAdd(arg1, arg2) {
      let r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = arg2.toString().split(".")[1].length
      } catch (e) {
        r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2))
      return (arg1.mul(m)  + arg2.mul(m)).div(m)
    }

    return accAdd(arg, this);
  }

//重写js减法运算
  Number.prototype.sub = function (arg) {
    function accsubtract(arg1, arg2) {
      let r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = arg2.toString().split(".")[1].length
      } catch (e) {
        r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2))
      return (arg1.mul(m)  - arg2.mul(m)) / m
    }

    return accsubtract(this, arg);
  }
}



// WEBPACK FOOTER //
// ./src/commonJs/objExtend/Number_E.js